/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Two_Plus_OneInputs */

const cs_enum_two_plus_one = /** @type {(inputs: Enum_Two_Plus_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2+1`)
};

const en_enum_two_plus_one = /** @type {(inputs: Enum_Two_Plus_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2+1`)
};

/**
* | output |
* | --- |
* | "2+1" |
*
* @param {Enum_Two_Plus_OneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_two_plus_one = /** @type {((inputs?: Enum_Two_Plus_OneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Two_Plus_OneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_two_plus_one(inputs)
	return cs_enum_two_plus_one(inputs)
});